
/* injects from baggage-loader */

'use strict';

import SpriteMagico from '_images/mapa-das-ilhas/dialogos/Matemágico.png';

export default class DialogMatemagicoController {
	constructor($log, $timeout) {
		'ngInject';
		this.$log = $log;
		this.$timeout = $timeout;
		this.magicoSprite = SpriteMagico;
		this.step = 0;
		this.class = "fade-in";
	}

	$onInit() {
		this.text = this.resolve.text;
		this.name = this.resolve.name;
		
		this.current(this.step);
	}

	current(){
		let text = this.text;
		let index = this.step;
		if(Array.isArray(text[index]))
			this.currentText = text[index][0]+this.name+text[index][1]
		else
			this.currentText = text[index];
	}

	changeStep(num){
		let $ctrl = this;
		if(num>0){
			this.nextStep();
			this.class="fade-out";
		}
		else{
			if(this.step!==0){
				this.class="fade-out";
				this.prevStep();
			}
		}
		this.$timeout(function(){
			$ctrl.class = "fade-in";
			$ctrl.current();
		},200)
	}

	nextStep(){
		if(this.text.length-2>=this.step)
			this.step++;
		else
			this.ok();		
	}

	prevStep(){
		if(this.step<=0)
			this.step = 0;
		else
			this.step--;
	}

	ok(){
		this.modalInstance.close(true);
	}

	cancel(){
		this.modalInstance.dismiss('cancel');
	}
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/matemagico/matemagico.controller.js